var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-crud',{attrs:{"crudName":"Tickets","newText":"Novo Ticket","table":_vm.projectTable,"columns":_vm.columns,"options":_vm.options,"endPoint":_vm.endPoint,"enableAdd":_vm.admin,"enableEdit":true,"enableDelete":true,"enableView":true,"dataForm":_vm.dataForm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }